import React from 'react';
import { Table } from '@landr/maestro';
import useSortingOption, {
    SamplesTableSortingTypes,
} from 'components/DetailsView/components/useSortingOptionItem';

export interface SamplesCellProps {
    children?: React.ReactNode;
    isHidden?: boolean;
    width?: string;
    textAlign?: string;
    className?: string;
    'data-is-lg'?: boolean;
    'data-is-md'?: boolean;
    isSortable?: boolean;
    sortingType?: SamplesTableSortingTypes;
}

const SamplesCell: React.FC<SamplesCellProps> = ({
    children,
    isHidden,
    width,
    textAlign,
    className,
    'data-is-lg': isLg,
    'data-is-md': isMd,
    isSortable,
    sortingType,
    ...props
}) => {
    if (isHidden) {
        return null;
    }

    const { callback, currentDirection, currentType } = useSortingOption({
        type: sortingType ?? null,
    });

    return (
        <Table.Cell
            cursor="pointer"
            width={width}
            textAlign={textAlign}
            className={className}
            data-is-lg={isLg}
            data-is-md={isMd}
            boxSizing="content-box"
            paddingX="2xs"
            justifyContent="flex-start"
            isSortable={isSortable}
            onClick={callback}
            sortDirection={currentDirection === 'ascending' ? 'asc' : 'desc'}
            isSorted={currentType === sortingType}
            {...props}
        >
            {children}
        </Table.Cell>
    );
};

export default SamplesCell;
